<app-menu-user-button-item (click)="logout()">
  <mat-icon icon>logout</mat-icon>
  <span label>Se déconnecter</span>
</app-menu-user-button-item>
